import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column, Text } from '@dossierhq/design';
import { MapContainer } from '@dossierhq/leaflet';
export function PublishedEntityMapMarker({ color, entity, location, onClick }) {
    return (_jsx(MapContainer.Marker, { color: color, location: location, tooltip: _jsxs(Column, { children: [_jsx(Text, { textStyle: "subtitle1", children: entity.info.name }), _jsx(Text, { textStyle: "body1", children: entity.info.type })] }), onClick: onClick }));
}
//# sourceMappingURL=PublishedEntityMapMarker.js.map